import hideMainMenu from './hide-main-menu';

export default {
  hideMainMenu,
};
